import { Component, ViewChild } from '@angular/core';
import { TranslatePipe } from '../../../../pipes/translate/translate.pipe';
import { IconComponent } from '../../../ui/icon/icon.component';
import { ToggleArrowComponent } from 'src/app/shared/components/ui/toggle-arrow/toggle-arrow.component';
import { Align, PopupModule } from '@progress/kendo-angular-popup';
import { CommonModule } from '@angular/common';
import { CellActionType } from '../../../../../features/bizzmine/widgets/collection-list-widget/classes/cell-action-type';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { ContextMenuComponent, MenusModule } from '@progress/kendo-angular-menu';

@Component({
  selector: 'bizz-grid-cell-notification-and-reminder-actions',
  standalone: true,
  templateUrl: './grid-cell-notification-and-reminder-actions.component.html',
  styleUrl: './grid-cell-notification-and-reminder-actions.component.scss',
  imports: [CommonModule, TranslatePipe, IconComponent, PopupModule, MenusModule, ToggleArrowComponent]
})
export class GridCellNotificationAndReminderActionsComponent extends GridCellBaseComponent<string> {
  public popupAnchorAlign: Align = { horizontal: 'left', vertical: 'bottom' };
  public isMenuOpen: boolean = false;

  @ViewChild('menu', { static: true }) public menu: ContextMenuComponent;

  public constructor() {
    super();
  }

  public openNotificationDetail(id: number): void {
    this.onCellAction.emit({ action: CellActionType.NOTIFICATION_OPEN, data: { data: this.data } });
    this.menu.hide();
  }

  public readNotification(): void {
    this.onCellAction.emit({ action: CellActionType.NOTIFICATION_READ, data: { data: this.data } });
    this.menu.hide();
  }

  public unreadNotification(): void {
    this.onCellAction.emit({ action: CellActionType.NOTIFICATION_UNREAD, data: { data: this.data } });
    this.menu.hide();
  }
}
